import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Delete from "./Delete.js"
import Detail from "./Detail.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"



class Marcos extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create:true,
                        permission: 'marcosdeplan_add',
                        component: Create,
                    },
                    {
                        edit:true,
                        permission: 'marcosdeplan_edit',
                        component: Edit,
                    },
                    {
                        detail: true,
                        permission: 'marcosdeplan_detail',
                        component: Detail,
                    },
                    {
                        edit:true,
                        permission: 'marcosdeplan_delete',
                        component: Delete,
                    }
                ]}

                apiUrl={api.proyectos.config.plan.marcos.list}
                columns={this.state.columns}
                exportUrl={api.proyectos.config.plan.marcos.export}
                title={"Modos de Vinculación"}
                outerSort={[{"id":"nombre","desc":false}]}
            />
        );
    }
}

export default Marcos;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Plan_Marcos/Marcos.js